import { render, staticRenderFns } from "./repartition-bar-vertical.vue?vue&type=template&id=88df9cf2&scoped=true"
import script from "./repartition-bar-vertical.vue?vue&type=script&lang=js"
export * from "./repartition-bar-vertical.vue?vue&type=script&lang=js"
import style0 from "./repartition-bar-vertical.vue?vue&type=style&index=0&id=88df9cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88df9cf2",
  null
  
)

export default component.exports